/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import {
  Col,
  Collapse,
  ControlLabel,
  Form,
  FormGroup,
  Grid,
  Panel,
  Row,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import Select from 'loracoms/Select';
import Nvl from 'loracoms/Nvl';
import CollapseToggle from 'loracoms/CollapseToggle';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import deviceActions from 'loraactions/device';
import IntlMsg from 'lorautils/intl/IntlMsg';
import RxParamSetupReq from './coms/RxParamSetupReq';
import RxTimingSetupReq from './coms/RxTimingSetupReq';
import DutyCycleReq from './coms/DutyCycleReq';
import DevStatusReq from './coms/DevStatusReq';
import LinkADRReq from './coms/LinkADRReq';
import NewChannelReq from './coms/NewChannelReq';
import DlChannelReq from './coms/DlChannelReq';
import TxParamSetupReq from './coms/TxParamSetupReq';
import UdpChPlanReq from './coms/UdpChPlanReq';
import AddBroadcastReq from './coms/AddBroadcastReq';
import RemoveBroadcastReq from './coms/RemoveBroadcastReq';
import UpdChPlanReq2 from './coms/UdpChPlanReq2';
import AddBroadcastReqV2 from './coms/AddBroadcastReqV2';
import RemoveBroadcastReqV2 from './coms/RemoveBroadcastReqV2';
import MacLog from './coms/MacLog';
import MacHelp from './coms/MacHelp';
import styles from './styles.scss';


const kCommands = [
  'RXParamSetupReq',
  'TXParamSetupReq',
  'RXTimingSetupReq',
  'DutyCycleReq',
  'DevStatusReq',
  'LinkADRReq',
  'NewChannelReq',
  'DLChannelReq',
  'UpdChPlanReq',
  'AddBroadcastReq',
  'RemoveBroadcastReq',
  'UpdChPlanReqV2',
  'AddBroadcastReqV2',
  'RemoveBroadcastReqV2',
];

const kCommandOptions = kCommands.map(cmd => ({
  label: cmd,
  value: cmd,
}));

const propTypes = {
  pushState: React.PropTypes.func.isRequired,
  deviceState: React.PropTypes.object.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  getDevice: React.PropTypes.func.isRequired,
  getMacTxSize: React.PropTypes.func.isRequired,
  txSize: React.PropTypes.object.isRequired,
  plan: React.PropTypes.object.isRequired,
  appState: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

class MacView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      deviceState: props.deviceState,
      appState: props.appState,
      txSize: props.txSize,
      command: 'RXParamSetupReq',
    };
    this.handleSelectCommand = this.handleSelectCommand.bind(this);
    this.handleRefreshTxSize = this.handleRefreshTxSize.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
  }

  componentWillMount() {
    const { deviceId, getMacTxSize } = this.props;
    getMacTxSize(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, txSize, plan, appState } = nextProps;
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (txSize !== this.props.txSize) {
      this.setState({ txSize });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  handleSelectCommand(command) {
    this.setState({ command });
  }

  handleRefreshTxSize() {
    const { deviceId, getDevice, getMacTxSize } = this.props;
    getDevice(deviceId);
    getMacTxSize(deviceId);
  }

  renderToolbar() {
    const { appId, deviceId } = this.props;
    const {
      deviceState: {
        data: { name } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;

    const breadcrumb = [{
      content: <FormattedMessage id="application.breadcrumb.application" />,
      onClick: () => this.props.pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => this.props.replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];

    return (
      <Toolbar breadcrumb={breadcrumb} />
    );
  }

  renderForm() {
    const { deviceId } = this.props;
    const { command } = this.state;
    let form;
    if (command === 'RXParamSetupReq') {
      form = <RxParamSetupReq deviceId={deviceId} />;
    } else if (command === 'RXTimingSetupReq') {
      form = <RxTimingSetupReq deviceId={deviceId} />;
    } else if (command === 'DutyCycleReq') {
      form = <DutyCycleReq deviceId={deviceId} />;
    } else if (command === 'DevStatusReq') {
      form = <DevStatusReq deviceId={deviceId} />;
    } else if (command === 'LinkADRReq') {
      form = <LinkADRReq deviceId={deviceId} />;
    } else if (command === 'NewChannelReq') {
      form = <NewChannelReq deviceId={deviceId} />;
    } else if (command === 'DLChannelReq') {
      form = <DlChannelReq deviceId={deviceId} />;
    } else if (command === 'TXParamSetupReq') {
      form = <TxParamSetupReq deviceId={deviceId} />;
    } else if (command === 'UpdChPlanReq') {
      form = <UdpChPlanReq deviceId={deviceId} />;
    } else if (command === 'AddBroadcastReq') {
      form = <AddBroadcastReq deviceId={deviceId} />;
    } else if (command === 'RemoveBroadcastReq') {
      form = <RemoveBroadcastReq deviceId={deviceId} />;
    } else if (command === 'UpdChPlanReqV2') {
      form = <UpdChPlanReq2 deviceId={deviceId} />;
    } else if (command === 'AddBroadcastReqV2') {
      form = <AddBroadcastReqV2 deviceId={deviceId} />;
    } else if (command === 'RemoveBroadcastReqV2') {
      form = <RemoveBroadcastReqV2 deviceId={deviceId} />;
    }
    return (
      <div className={styles.macform}>
        <Form horizontal onSubmit={e => e.preventDefault()}>
          <FormGroup>
            <Col md={3}>
              <ControlLabel bsClass="aisz-control-label">
                { this.intlMsg.msg('selectmac') }
              </ControlLabel>
            </Col>
            <Col md={6}>
              <Select
                className="aisz-form-control-f"
                options={kCommandOptions}
                onChange={this.handleSelectCommand}
                value={command}
              />
            </Col>
          </FormGroup>
        </Form>
        {form}
      </div>
    );
  }

  renderMacCommand() {
    const { command, txSize, expanded = true } = this.state;
    const { data: { size } = {}, status } = txSize;

    const header = (
      <div>
        {this.intlMsg.msg('maccommand')}
        <ul className="icontools">
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Row>
        <Col md={7}>
          <Panel
            bsStyle="aisz-white"
            header={header}
            collapsible
            expanded={expanded}
          >
            {this.renderForm()}
          </Panel>
        </Col>
        <Col md={5}>
          <Collapse in={expanded}>
            <div>
              <div className={styles.qsize}>
                <span className={styles.title}>
                  {this.intlMsg.msg('sendqueue')}
                </span>
                <span className={styles.value}>
                  <Nvl val={size} status={status} />
                </span>
                {' '}
                <Link onClick={this.handleRefreshTxSize}>
                  <span className="halflings halflings-refresh" />
                  {' '}{this.intlMsg.msg('refresh')}
                </Link>
              </div>
              <MacHelp command={command} />
            </div>
          </Collapse>
        </Col>
      </Row>
    );
  }

  renderContent() {
    const { deviceId } = this.props;

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderMacCommand()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MacLog deviceId={deviceId} />
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { plan: { status, data } } = this.state;
    if (status !== 'success') {
      return <PageLoading />;
    }
    if (data.tier === 1) {
      return <PageNoPerm />;
    }
    return this.renderContent();
  }
}

MacView.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  plan: state.billing.plan,
  deviceState: state.device.getDevice,
  appState: state.app.getApp,
  txSize: state.device.getMacTxSize,
  appId: ownProps.params.appId,
  deviceId: ownProps.params.deviceId,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
  getDevice: deviceActions.getDevice,
  getMacTxSize: deviceActions.getMacTxSize,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MacView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/index.jsx